export class CalendarMenuItem {
  title: string;
  id: string;
  matIcon: string;
}
